module.exports = __webpack_public_path__ + "img/mo.0002efce.svg";